import { GetServerSidePropsContext } from 'next';
import React from 'react';
import PageESIWrapper from 'src/components/page-esi-wrapper/page-esi-wrapper.component';
import PageHead from 'src/components/page-head/page-head.component';
import PreviewBannerComponent from 'src/components/preview-banner/preview.banner-component';
import { getCanonicalUrl, getPageHeaderData } from 'src/utils/pageheader';
import {
  isPreviewMode,
  PageData,
  SSR_STATUS_CODES,
} from 'src/utils/ssr-helper';
import HELP from '../../src/components/faq/genesys-help';

export const getStaticProps = async ({ locale }: GetServerSidePropsContext) => {
  const pageData = {
    status: SSR_STATUS_CODES.SUCCESS,
    errorCode: 0,
    errorMessage: null,
    content: null,
    pageHeader: await getPageHeaderData(
      'Knowledge Portal',
      'Virgin Atlantic - Knowledge Portal',
      getCanonicalUrl('/help'),
      { hideSearchPanel: true },
      new Date().toISOString(),
    ),
    localeInfo: locale,
  };
  return {
    props: {
      ...pageData,
    },
    revalidate: 1,
  };
};

export const getGenesysPath = (locale: string) => {
  const helpPath = '/help';
  const previewPath = isPreviewMode ? '/preview' : '';
  const localePath = !locale || locale === 'en-GB' ? '' : `/${locale}`;
  return `${previewPath}${localePath}${helpPath}`;
};

const Page = ({ localeInfo, pageHeader }: PageData) => {
  return (
    <div>
      {pageHeader && <PageHead {...pageHeader} />}
      <PageESIWrapper
        localeInfo={localeInfo}
        searchPanelConfig={pageHeader?.searchPanelConfig}>
        {isPreviewMode && <PreviewBannerComponent />}
        <div style={{ overflow: 'auto', overflowX: 'hidden' }}>
          <HELP path={getGenesysPath(localeInfo)} />
        </div>
      </PageESIWrapper>
    </div>
  );
};

export default Page;
